export default __webpack_public_path__ + "static/media/aa-12.cfa53148.svg";